import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IOption } from '@shared/models/icommons.model';
import { SharedService } from '@shared/services/shared.service';
import { Observable, of } from 'rxjs';
import { map, debounceTime } from 'rxjs/operators';
import { UserInfoResolver } from '@shared/resolvers/user-info.resolver';

const CUSTOM_FILTERS = {
  lease: {
    filters: ({ isAUsBroker }) =>
      isAUsBroker
        ? [
            {
              type: 'multi',
              field: 'lease_record_type_desc',
              key: 423,
              values: ['Lease Comp', 'Partial Lease Comp', 'Owner Occupied'],
              dataType: 'text',
              name: 'Record Type',
            },
          ]
        : [],
  },
};

@Component({
  selector: 'miq-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  standalone: false,
})
export class SearchComponent implements OnInit, OnDestroy {
  public searchControl = new UntypedFormControl();
  public textSearch: Observable<IOption[]> = of([]);

  @Input() userId: number;
  @Input() entity: string;
  @Input() filters: any[] = [];
  @Output() newRecord = new EventEmitter<any>();

  constructor(
    private sharedService: SharedService,
    private userInfoResolver: UserInfoResolver
  ) {}

  ngOnInit() {
    const isAUsBroker = this.userInfoResolver.isUsBroker();
    const _filters = CUSTOM_FILTERS?.[this.entity]?.filters({ isAUsBroker });
    if (_filters) {
      this.filters = [...this.filters, ..._filters];
    }
    this.searchControl.valueChanges.pipe(debounceTime(500)).subscribe(this.search.bind(this));
  }

  public search(value) {
    if (value.trim()) {
      return (this.textSearch = this.sharedService
        .searchRecords(
          {
            entity: this.entity.toLowerCase(),
            userId: this.userId,
            query: value,
            filters: [
              {
                dataType: 'text',
                field: [],
                type: 'multifield',
                values: value.trim(),
              },
              ...this.filters,
            ],
          },
          10
        )
        .pipe(map(({ results }) => results)));
    }
    return (this.textSearch = of([]));
  }

  public addRecord(record: IOption) {
    this.textSearch = of([]);
    this.newRecord.emit(record);
  }

  ngOnDestroy() {
    /** label translation purpose added */
  }
}
